import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {NoteService} from '../../services/note_service';
import {NoteRating} from '../../types/note_rating';

@Component({
  selector: 'app-rate-note-modal',
  templateUrl: './rate-note-modal.component.html',
  styleUrls: ['./rate-note-modal.component.scss']
})
export class RateNoteModalComponent implements OnInit {
  @Input() public note: any;
  @Input() public userRate: string;
  @Input() public previousRatings: NoteRating[];
  @Output() rateAddedEvent: EventEmitter<any> = new EventEmitter();

  public comment: string;
  public subject: string;
  public rating: any = 0;
  ratingComments: any = [];
  ratingInvalid = false;
  subjectInvalid = false;
  commentInvalid = false;

  constructor(public activeModal: NgbActiveModal,
              public noteService: NoteService) { }

  ngOnInit() {
    this.rating = (this.userRate) ? this.userRate : this.rating;
    this.getNoteRatings();
  }

  submitRate() {
    const review = {
      rating: this.rating,
      subject: this.subject,
      comments: this.comment
    };

    if (!review.rating) {
      this.ratingInvalid = true;
    } else if (review.rating && ((!review.subject && review.comments) || (review.subject && !review.comments))) {
      this.ratingInvalid = false;
      this.subjectInvalid = (!review.subject) ? true : false;
      this.commentInvalid = (!review.comments) ? true : false;
    } else {
      this.ratingInvalid = false;
      this.subjectInvalid = false;
      this.commentInvalid = false;

      this.noteService.rateNote(this.note.id, review)
        .then((response: NoteRating) => {
          this.rateAddedEvent.emit(true);
          this.activeModal.close(response);
        })
        .catch((err) => {
          console.log('error adding rating', err);
          this.activeModal.dismiss('error saving rating');
        });
    }
  }

  getNoteRatings() {
    this.noteService.getNoteRatings(this.note.id)
      .then(res => {
        this.ratingComments = res;
      });
  }

}
